export default class SanityTools {
    static cardImage(imageUrl: string) {
        return imageUrl + '?h=300'
    }
}
